module.exports = __webpack_public_path__ + "static/media/delivery_modern.9076e1a0.png";